var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6875 52.0625V24.6094H51.1875V55.5625H4.92188V24.8281H8.42188V52.0625H47.6875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35345 0.4375H49.6442L55.5625 20.086V20.3438C55.5625 24.1376 52.4657 27.2344 48.6719 27.2344C46.6328 27.2344 44.795 26.3398 43.5312 24.9232C42.2675 26.3398 40.4297 27.2344 38.3906 27.2344C36.3352 27.2344 34.4844 26.3254 33.2198 24.8891C31.9361 26.3267 30.0702 27.2344 28 27.2344C25.9298 27.2344 24.0639 26.3267 22.7802 24.8891C21.5156 26.3254 19.6648 27.2344 17.6094 27.2344C15.5703 27.2344 13.7325 26.3398 12.4687 24.9232C11.205 26.3398 9.36726 27.2344 7.32812 27.2344C3.58377 27.2344 0.4375 24.2958 0.4375 20.4531V20.1967L6.35345 0.4375ZM10.7187 20.3438H14.2187C14.2187 22.2046 15.7485 23.7344 17.6094 23.7344C19.4702 23.7344 21 22.2046 21 20.3438V20.2344H24.5C24.5 22.1554 26.079 23.7344 28 23.7344C29.921 23.7344 31.5 22.1554 31.5 20.2344H35V20.3438C35 22.2046 36.5298 23.7344 38.3906 23.7344C40.2515 23.7344 41.7812 22.2046 41.7812 20.3438H45.2812C45.2812 22.2046 46.811 23.7344 48.6719 23.7344C50.4549 23.7344 51.934 22.3298 52.0546 20.5753L47.0431 3.9375H8.95905L3.94548 20.6828C4.06443 22.3878 5.49919 23.7344 7.32812 23.7344C9.18898 23.7344 10.7187 22.2046 10.7187 20.3438Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 32.4844H36.3125V53.8125H32.8125V35.9844H23.1875V53.8125H19.6875V32.4844Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 18.0469V20.2344H21V18.0469H24.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2188 18.0469V20.4531H10.7188V18.0469H14.2188Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 18.0469V20.2344H31.5V18.0469H35Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2812 18.0469V20.4531H41.7812V18.0469H45.2812Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.ca6a93c1a317054380469eba9d1d5b37.svg";
export { ForwardRef as ReactComponent };